import { net_filemanage } from "@/api/http";
export const API_STFMFM02C29_Initialize = (...params) =>
net_filemanage.post("/api/STFMFM02C29/Initialize", ...params)
export const API_STFMFM02C29_SaveInfo = (...params) =>
net_filemanage.post("/api/STFMFM02C29/SaveInfo", ...params)